import { render, staticRenderFns } from "./BarMultid.vue?vue&type=template&id=6578b334&scoped=true"
import script from "./BarMultid.vue?vue&type=script&lang=js"
export * from "./BarMultid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6578b334",
  null
  
)

export default component.exports